import React from 'react';

import './Padding.css';

interface PaddingProps {
  children: React.ReactNode;
  withSafeArea?: boolean;
}

const Padding: React.FC<PaddingProps> = ({ children, withSafeArea = true }) => {
  return (
    <div className={`padding ${withSafeArea ? 'padding--with-safe-area' : ''}`}>
      {children}
    </div>
  );
};

export default Padding;
